"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnsByRegionLetters = void 0;
var react_1 = require("react");
var reduce_1 = __importDefault(require("lodash/reduce"));
var wideContainer_1 = require("@r1-frontend/ui-react/components/layouts/wideContainer");
var useMatchMedia_1 = require("@r1-frontend/shared/hooks/useMatchMedia");
var useColumnsByRegionLetters = function (_a) {
    var regions = _a.regions, topCities = _a.topCities;
    var _b = __read([
        (0, useMatchMedia_1.useMatchMediaByWidth)(wideContainer_1.wideBreakpoints.mobile, true),
        (0, useMatchMedia_1.useMatchMediaByWidth)(wideContainer_1.wideBreakpoints.tablet, true),
        (0, useMatchMedia_1.useMatchMediaByWidth)(wideContainer_1.wideBreakpoints.laptop, true),
    ], 3), isTablet = _b[0], isLaptop = _b[1], isDesktop = _b[2];
    var _c = (0, react_1.useMemo)(function () {
        switch (true) {
            case isDesktop:
                return {
                    firstColumnSize: 6,
                    columnsCount: 4,
                };
            case isLaptop:
                return {
                    firstColumnSize: 8,
                    columnsCount: 3,
                };
            case isTablet:
                return {
                    firstColumnSize: 16,
                    columnsCount: 2,
                };
            default:
                return {
                    firstColumnSize: 0,
                    columnsCount: 1,
                };
        }
    }, [isDesktop, isLaptop, isTablet]), firstColumnSize = _c.firstColumnSize, columnsCount = _c.columnsCount;
    var regionsCount = (0, reduce_1.default)(regions, function (result, value) { return result + value.length; }, 0);
    return (function () {
        var e_1, _a;
        var otherColRegionSize = Math.round(regionsCount / columnsCount) +
            ((!!firstColumnSize && !!topCities.length) ? Math.round(firstColumnSize / columnsCount) : 0);
        var map = new Map();
        var result = [];
        var regionLetters = Object.keys(regions);
        var currCol = 0;
        var currCount = 0;
        try {
            for (var regionLetters_1 = __values(regionLetters), regionLetters_1_1 = regionLetters_1.next(); !regionLetters_1_1.done; regionLetters_1_1 = regionLetters_1.next()) {
                var letter = regionLetters_1_1.value;
                var mid = currCount + regions[letter].length / 2;
                if (topCities.length && !!firstColumnSize && firstColumnSize < currCount && currCol === 0) {
                    result.push(Object.fromEntries(map.entries()));
                    currCount = 0;
                    map.clear();
                    currCol += 1;
                }
                if (otherColRegionSize < mid) {
                    result.push(Object.fromEntries(map.entries()));
                    currCount = 0;
                    map.clear();
                }
                map.set(letter, regions[letter]);
                currCount += regions[letter].length;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (regionLetters_1_1 && !regionLetters_1_1.done && (_a = regionLetters_1.return)) _a.call(regionLetters_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (map.size) {
            result.push(Object.fromEntries(map.entries()));
        }
        return result;
    })();
};
exports.useColumnsByRegionLetters = useColumnsByRegionLetters;
